import { memo, Fragment } from 'react';
import { clsx } from 'clsx';
import { FormattedMessage } from 'react-intl';
import { Heading } from '@library';
import Modal from '../../../../core/components/Modal';
import useTabletView from '../../../../core/hooks/dom/useTabletView';
import type { ReplacementProductDetails } from '../../../types';
import Divider from '../../../../core/components/Divider';
import styles from './ReplacementProducts.module.scss';
import ReplacementProductsDropdownItem from './ReplacementProductsDropdownItem';

const ReplacementProductsDropdown = memo(
    ({
        replacementProducts,
    }: {
        replacementProducts: ReplacementProductDetails[];
    }) => {
        return (
            <div className={styles.replacementProductItemContainer}>
                {replacementProducts.map((product, index) => {
                    return (
                        <Fragment key={product.sku}>
                            {index !== 0 && (
                                <div className={styles.divider}>
                                    <Divider light lengthPercentage={100} />
                                </div>
                            )}
                            <ReplacementProductsDropdownItem
                                product={product}
                            />
                        </Fragment>
                    );
                })}
            </div>
        );
    }
);

const ProductReplacementDetailsDropdown = ({
    isOpen,
    replacementProducts,
    onClose,
}: {
    isOpen: boolean;
    replacementProducts: ReplacementProductDetails[];
    onClose(): void;
}) => {
    const isTabletView = useTabletView();

    if (isTabletView) {
        if (isOpen) {
            return (
                <Modal wide scrollableOverflowContent onClose={onClose}>
                    <Heading h3 bold>
                        <FormattedMessage id="replacement item" />
                    </Heading>
                    <div
                        className={styles.replacementProductsModalContent}
                        data-test-class="replacementProductsModal"
                    >
                        <ReplacementProductsDropdown
                            replacementProducts={replacementProducts}
                        />
                    </div>
                </Modal>
            );
        }

        return null;
    }

    return (
        <div
            className={clsx(styles.menu, {
                [styles.menuOpened]: isOpen,
            })}
            data-test-class="replacementProductsDropdown"
        >
            <ReplacementProductsDropdown
                replacementProducts={replacementProducts}
            />
        </div>
    );
};

export default memo(ProductReplacementDetailsDropdown);
